import { FC } from 'react'

import { cn } from '@bem-react/classname'

import { Card } from '@/components/UI/Card'

import './TrustUs.scss'

const cnTrustUs = cn('TrustUs')

interface TrustUsProps {
  className?: string
}

export const TrustUs: FC<TrustUsProps> = ({
  className,
}: TrustUsProps): JSX.Element => {
  // const wallets = useAppSelector(walletsSelector)

  // const [symbols, setSymbols] = useState<string[]>([])
  // console.log(symbols)

  // useEffect(() => {
  //   if (wallets.length) {
  //     const res = getSymbolsHierarchy(wallets)

  //     setSymbols(res)
  //   }
  // }, [wallets])

  return (
    <div className={cnTrustUs(null, [className])}>
      <div className={cnTrustUs('wrap')}>
        <div className={cnTrustUs('title')}>
          <span>Why you should</span> <br /> trust us
        </div>
        {/* <div className={cnTrustUs('info')}>
          <div className={cnTrustUs('item')}>
            <div className={cnTrustUs('value')}>10,495.49 USD</div>
            <div className={cnTrustUs('key')}>Total balance</div>
          </div>

          {symbols.length > 0 && (
            <div className={cnTrustUs('item')}>
              <div className={cnTrustUs('value')}>
                {symbols.length}

                <div className={cnTrustUs('symbols')}>
                  {symbols.map((symbol, i) => (
                    <div
                      key={i}
                      className={cnTrustUs(
                        'symbol',
                        `icon-${symbol.toUpperCase()} ${symbol.toUpperCase()}-color-bg`,
                      )}
                    ></div>
                  ))}
                </div>
              </div>
              <div className={cnTrustUs('key')}>Assets</div>
            </div>
          )}
        </div> */}
      </div>
      <div className={cnTrustUs('cards')}>
        <Card className={cnTrustUs('card')}>
          <div className={cnTrustUs('subtitle')}>Fair pricing</div>
          <div className={cnTrustUs('text')}>
            You always get the amount stated in the&nbsp;you Receive
            field.&nbsp;No hidden fees or extra charges
          </div>
        </Card>
        <Card className={cnTrustUs('card')}>
          <div className={cnTrustUs('subtitle')}>Fast KYC</div>
          <div className={cnTrustUs('text')}>
            Upload Documents. In about 5 minutes&shy;you will have full access.
          </div>
        </Card>
        <Card className={cnTrustUs('card')}>
          <div className={cnTrustUs('subtitle')}>High limits</div>
          <div className={cnTrustUs('text')}>
            Up to&nbsp;5,000 EUR&nbsp;per transaction Up to&nbsp;12
            transactions&nbsp;per day
          </div>
        </Card>
        <Card className={cnTrustUs('card')}>
          <div className={cnTrustUs('subtitle')}>Instant exchange</div>
          <div className={cnTrustUs('text')}>
            We have our&nbsp;own crypto reserves&nbsp;for instant exchange
          </div>
        </Card>
      </div>
    </div>
  )
}
